import { AnalyticsInitParams, AnalyticsIntegration } from "./types.analytics"

class ABTestingClient implements AnalyticsIntegration {
	private apiKey: string | null = null
	private initialized = false

	public initialize(params: AnalyticsInitParams): void {
		const apiKey = params.apiKey || null
		if (!apiKey) {
			console.error(
				"Error: Amplitude Experiment API key is not defined. Please provide a valid API key."
			)
			return
		}

		if (this.initialized) {
			console.warn("Amplitude Experiment is already initialized")
			return
		}

		this.apiKey = apiKey
		this.setupAmplitudeExperiment()
		this.initialized = true
	}

	public isInitialized(): boolean {
		return this.initialized
	}

	public trackEvent(): void {
		// Experiments do not track arbitrary events through this client
	}

	private setupAmplitudeExperiment(): void {
		this.addAmplitudeScript()
	}

	private addAmplitudeScript(): void {
		const script = document.createElement("script")
		script.type = "text/javascript"
		script.src = `https://cdn.amplitude.com/script/${this.apiKey}.experiment.js`
		script.async = true

		script.onerror = (e) => {
			console.error("Error loading Amplitude Experiment script:", e)
		}

		document.body.appendChild(script)
	}
}

export default ABTestingClient
